// extracted by mini-css-extract-plugin
export default {"container":"ShopInformationStack_container__0e3Sk","shopImg":"ShopInformationStack_shopImg__kc7D1","shopAddress":"ShopInformationStack_shopAddress__m9WvA"};